import { render } from "./GateAuth.vue?vue&type=template&id=5e8d2c9a"
import script from "./GateAuth.vue?vue&type=script&lang=js"
export * from "./GateAuth.vue?vue&type=script&lang=js"

import "./GateAuth.vue?vue&type=style&index=0&id=5e8d2c9a&scroped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__